<template>
  <div :class="pclass" class="gp-main-body-content" v-if="shopPlan != 'trial' && show">
    <!-- <h1 class="main__title">{{title}}</h1> -->
    <div class="panel d-flex full-height">
      <div class="thankyou m-auto mt-6">
        <div class="thankyou__content">
          <section class="plan-icon animated" :class="[{ animated: type == 'up' }, shopPlan]">
            <template v-if="shopPlan == 'starter'">
              <!-- <img class="blackout-circle" :src="publicPath + require('../assets/circle-starter.svg')" />
              <img class="confetti" :class="{ 'appeared': animateDone }" :src="publicPath + require('../assets/confetti-normal.svg')" />
              <img class="gem" :src="publicPath + require('../assets/gem-starter.svg')" /> -->
              <CircleStarter class="blackout-circle" />
              <Confetti class="confetti" :class="{ 'appeared': animateDone }" />
              <GemStarter class="gem" />
            </template>
            <template v-else-if="shopPlan == 'professional'">
              <!-- <img class="blackout-circle" :src="publicPath + require('../assets/circle-pro.svg')" />
              <img class="confetti" :class="{ 'appeared': animateDone }" :src="publicPath + require('../assets/confetti-normal.svg')" />
              <img class="gem" :src="publicPath + require('../assets/gem-pro.svg')" /> -->
              <CirclePro class="blackout-circle" />
              <Confetti class="confetti" :class="{ 'appeared': animateDone }" />
              <GemPro class="gem" />
            </template>
            <template v-else>
              <!-- <img class="blackout-circle" :src="publicPath + require('../assets/circle-advanced.svg')" />
              <img class="confetti" :class="{ 'appeared': animateDone }" :src="publicPath + require('../assets/confetti-advanced.svg')" />
              <img class="gem" :src="publicPath + require('../assets/gem-advanced.svg')" /> -->
              <CircleAdvanced class="blackout-circle" />
              <Confetti type="advanced" class="confetti" :class="{ 'appeared': animateDone }" />
              <GemAdvanced class="gem" />
            </template>
          </section>

          <h1 class="typo-heading-24 typo-semibold text-light-high">
            <template v-if="type == 'up' && ['professional', 'advanced'].includes(shopPlan)">
              <span v-html="$t(`banner.thank${upperFirst(shopPlan == 'professional' ? 'business' : shopPlan)}`)" />
            </template>
            <template v-else>{{ $t("thanks.allSet") }}</template>
          </h1>
          <p class="typo-paragraph14 typo-regular-150 text-light-low mt-2" v-html="$t('thanks.thankYouContent')"></p>
        </div>
        <div class="thankyou__author mt-3 mb-6">
          <p class="typo-paragraph14 typo-regular-150 text-light-high">{{ $t("thanks.boss") }}</p>
          <p class="typo-paragraph14 typo-regular-150 text-light-low">{{ $t("thanks.role") }}</p>
        </div>
        <router-link :to="{ name: 'Dashboard' }" class="btn btn-lg btn-primary d-inline-block">{{ $t("thanks.back") }}</router-link>
        <!-- <button class="btn btn-lg btn-primary d-inline-block" @click="refreshAnimate">Refresh Animate</button>
        <button class="btn btn-lg btn-info d-inline-block ml-3" @click="changePlan">Change Plan</button> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
/* eslint-disable vue/no-unused-components */
import { CirclePro, CircleAdvanced, CircleStarter, GemPro, GemAdvanced, GemStarter, Confetti } from "../components/Thanks";
import upperFirst from "@/plugins/lodash/upperFirst.js";
import {Api, ApiUrl} from "@/services";
export default {
  name: "Thanks",
  components: {
    CirclePro,
    CircleAdvanced,
    CircleStarter,
    GemPro,
    GemAdvanced,
    GemStarter,
    Confetti,
  },
  props: ["pclass"],
  data() {
    return {
      //translation data
      thankYouContent: this.$t("thanks.thankYouContent"),
      title: this.$t("thanks.title"),
      titleBackup: "",
      type: "",
      show: false,
      animateDone: false,
      timeout: 0
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo,
      shopPlan: state => (state.shopInfo && state.shopInfo.plan) || "trial",
    })
  },
  watch: {
    "$route.query.type"(newV) {
      this.type = newV;
    }
  },
  beforeMount() {
    this.titleBackup = document.title;
    document.title = "Thankyou <3 | Gempages";
    this.type = this.$route.query.type;
    window.refreshAnimate = this.refreshAnimate;
    this.refreshAnimate();
  },
  mounted() {
    Api.base.get(ApiUrl.base.account.paymentInfo)
      .then(res => {
        if (res && res.data && res.data.message === 'success') {
          const price = res.data.data.price || 0;
          const currency = res.data.data.currency || 'USD';
          const planId = res.data.data.planId || 0;
          const planName = res.data.data.planName || 'trial';
          const planPrice = res.data.data.planPrice || 0;
          const subscriptionId = res.data.data.subscriptionId || 0;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'subscription',
            'subscription': {
              'id': subscriptionId,
              'value': price,
              'currency': currency,
              'items': [
                {
                  'item_id': planId,
                  'item_name': planName,
                  'value': planPrice,
                  'currency': currency,
                  'quantity': 1
                }
              ]
            }
          });
        }
      })
  },
  destroyed() {
    document.title = this.titleBackup || "Gempages Dashboard";
  },
  methods: {
    refreshAnimate() {
      this.show = false;
      this.animateDone = false;
      this.$nextTick(() => {
        this.show = true;
      })
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.animateDone = true;
      }, 1250);
    },
    upperFirst(val) {
      return upperFirst(val)
    },
    // changePlan() {
    //   let plan;
    //   if (this.shopPlan == "starter") {
    //     plan = "professional";
    //   } else if (this.shopPlan == "professional") {
    //     plan = "advanced";
    //   } else {
    //     plan = "starter";
    //   }
    //   this.$store.state.account.shopInfo.plan = plan;
    //   this.refreshAnimate();
    // },
  },
};
</script>

<style lang="scss" scoped>
.thankyou {
  padding: 40px 0;
  text-align: center;
}

@keyframes rotate-in-center {
  0% {
    transform: rotate(-360deg);
    opacity: 0;
  }
  100% {
    transform: rotate(0);
    opacity: 1;
  }
}

@keyframes slide-in-bottom {
  0% {
    transform: translateY(100px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes scale-in-center {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes wobble-hor-bottom {
  0%,
  100% {
    transform: translateX(0%);
    transform-origin: 50% 50%;
  }
  15% {
    transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    transform: translateX(15px) rotate(6deg);
  }
  45% {
    transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    transform: translateX(-6px) rotate(-1.2deg);
  }
}

@keyframes blinking {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}


.scale-in-center {
	animation: scale-in-center 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both !important;
}

.rotate-in-center {
  animation: rotate-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both !important;
}

.slide-in-bottom {
	animation: slide-in-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s both !important;
}

.wobble-hor-bottom {
	animation: blinking 1s infinite both !important;
}




.plan-icon {
  position: relative;
  @include flex-center;
  .blackout-circle {
    width: 200px;
    animation: scale-in-center 0.7s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }
  .gem {
    position: absolute;
    animation: slide-in-bottom 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.35s both;
  }
  .confetti {
    position: absolute;
    width: 270px;
    top: -40px;
    animation: scale-in-center 0.5s cubic-bezier(0.445, 0.050, 0.550, 0.950) 0.8s both;
  }

  &.advanced {
    .confetti {
      width: 367px;
      top: -70px;
    }
  }
}

</style>
